import { render, staticRenderFns } from "./product-details-shipping.vue?vue&type=template&id=33410b55&scoped=true&"
import script from "./product-details-shipping.vue?vue&type=script&lang=js&"
export * from "./product-details-shipping.vue?vue&type=script&lang=js&"
import style0 from "./product-details-shipping.vue?vue&type=style&index=0&id=33410b55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33410b55",
  null
  
)

export default component.exports